import { Row } from 'antd';
import React, { useEffect, useState } from 'react';

const FilterTagGroup = ({ border = true, value, onChange, children, defaultValue = '', multiple = false }) => {
  const [currValue, setCurrValue] = useState(defaultValue);
  const childrenArr = React.Children.toArray(children);

  useEffect(() => {
    if (!value) return;
    setCurrValue(value);
  }, [value]);

  return (
    <div className="TY_filter_tag">
      <div className="TY_filter_tag-inner">
        <Row gutter={[8, 8]}>
          {childrenArr.map((item) => {
            return React.cloneElement(item, {
              border,
              multiple,
              currValue: currValue,
              selected: multiple ? currValue.indexOf(item.props.value) !== -1 : currValue == item.props.value,
              onChange: (value) => {
                setCurrValue(value);
                onChange(value);
              },
            });
          })}
        </Row>
      </div>
    </div>
  );
};

export default React.memo(FilterTagGroup);
